import {EditService} from '@syncfusion/ej2-angular-gantt'
import {Component, Input, OnInit} from '@angular/core';
import {ApiPathsService} from "../../api-paths.service";
import { ToolbarService, PdfExportService } from '@syncfusion/ej2-angular-gantt';
import {IDropdownSettings} from "../../../LibrerieCustom/MultiselectDropdown";
import {DatePipe} from "@angular/common";
import { debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TaskService } from 'src/app/task/_service/task.service';
import { DownloadService } from 'src/app/shared/_services/download.service';
import { Azienda } from '../models/Azienda';
import { Persona } from '../models/persona';
import { ActivatedRoute } from '@angular/router';
import { CampoUtility } from 'src/app/shared/models/campo-aggiuntivo';
import { getWeekDayObjFromString } from 'src/environments/Utility/DateUtility';
import { OggettoConfig } from 'src/app/shared/_services/dynamic-crud.service';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DynamicEditComponent } from 'src/app/shared/dynamic-edit/dynamic-edit.component';
import { environment } from '../../../environments/environment';
import { Location } from '@angular/common';
import { StorageService } from 'src/app/shared/_services/filtri.service';


@Component({
  selector: 'app-registro-presenze',
  templateUrl: 'registro-presenze.component.html',
  styleUrls: ['./registro-presenze.component.scss'],
  providers: [EditService, ToolbarService, PdfExportService],
})
export class RegistroPresenzeComponent implements OnInit {
  private inputEventSubject: Subject<Event> = new Subject();
  public columns?: object[];
  public data?: object[];
  @Input() filtro: any = {};
  @Input() Entity: any[];
  @Input() Presenze: any[];
  @Input() report: any;
  Persone: any[];
  dropSetting: IDropdownSettings= { singleSelection: false, singleOutput: false, idField: 'id', textField: 'label',  allowSearchFilter: true, }
  dropSettingSingle: IDropdownSettings= { singleSelection: true, singleOutput: false, idField: 'id', textField: 'label',  allowSearchFilter: true, }
  dropSettingOnlySingle: IDropdownSettings= { singleSelection: true, singleOutput: true, idField: 'id', textField: 'label',  allowSearchFilter: true, }
  TaskType: string = 'P';
  EntityParam: 'manager' | 'cliente' = 'cliente';
  TaskSctructure;
  legenda: { area: string, legenda: {label: string, color:string} []} = {
    area: 'Legenda Presenze',
    legenda: [
      { label: 'Presente', color: '#00ff00' },
      { label: 'Assente', color: '#ff0000' },
      { label: 'Dimesso', color: '#000000' },
      { label: 'Assente/Ricovero', color: '#ffa500 ' },
      { label: 'Assente/TSO', color: '#ee82ee ' },
      { label: 'Assente/Famiglia', color: '#ffff00 ' },
      { label: 'Altro', color: '#0000ff ' },
    ],
  };
  envirovment = environment
  longWeek = false
  showClasse = false
  multipleState = false
  giorniFestivi : number[] = [6,7]
  classiList : any[] = []

  constructor(
    private apiPaths: ApiPathsService,
    private datepipe:DatePipe,
    private TaskService: TaskService,
    private downloadService: DownloadService,
    private route: ActivatedRoute,
    private campoUtility: CampoUtility,
    private Toastr: ToastrService,
    private modalService: NgbModal,
    private filtriService: StorageService,
    private location: Location
    ) {}


  public ngOnInit(): void {

    this.route.params.subscribe(data => {
      this.EntityParam = data['entity'] ?? 'cliente';
      this.TaskType = data['taskType'] ?? 'P';
      this.filtriService.getFiltri(this.location.path()).map(
        filtro => {
          this.filtro[filtro.campo] = filtro.value
        }
      )
      this.onInput(null);
    })




    if(this.envirovment.ClientiAddOn['legendaPresenze']){
      this.legenda.legenda = this.envirovment.ClientiAddOn['legendaPresenze']
    }
    if(this.envirovment.ClientiAddOn['longWeek']){
      this.longWeek = this.envirovment.ClientiAddOn['longWeek']
      this.getClassi()
    }
    if(this.envirovment.ClientiAddOn['showClasse']){
      this.showClasse = this.envirovment.ClientiAddOn['showClasse']
      if(this.showClasse)
        this.getClassi()
    }
    if(this.envirovment.ClientiAddOn['giorniFestivi']){
      this.giorniFestivi = this.envirovment.ClientiAddOn['giorniFestivi']
    }
    if(this.envirovment.ClientiAddOn['multipleState']){
      this.multipleState = this.envirovment.ClientiAddOn['multipleState']
    }
    this.inputEventSubject.pipe( debounceTime(500) ).subscribe(event => this.Refresh());
    this.initFilter();
    this.onInput(null);
  }
  onInput(event: Event): void {
    this.inputEventSubject.next(event);
  }
  Approve() {
    // var Presenze: any = this.columns.reduce((acc: any, cur: any) => [...acc, ...cur.Tasks], []);
    // Presenze = Presenze.filter(x => x?.task?.id)?.map(x => {
    //   var task = Object.assign({}, x?.task);
    //   task.Tasks = undefined;
    //   return task;
    // });
    // Presenze.forEach(x => {
    //   x.data_chiusura = this.datepipe.transform(new Date(), 'yyyy-MM-ddTHH:mm');
    //   x.data_attivita = x.data_inizio_prevista ?? x.data_attivita;
    //   x.att_chiusa = true;
    //   this.apiPaths.ClassicPost(`${this.TaskSctructure.restRoute}/update`, x).subscribe();
    // });
    // console.log(Presenze);

    var structure: OggettoConfig = {
      Id: '',
      RestRoute: this.TaskSctructure.restRoute,
      campi: [
        {
          nome: 'CodiceOtp',
          oggetti: ['codiceOtp'],
          modificabile: true,
          inputType: 'text',
          class: "col-lg-12",
          required: true
        },
      ]
    };

      this.apiPaths.ClassicPost(`${structure.RestRoute}/otp`, { inizio: this.filtro.inizio, fine: this.filtro.fine }).subscribe(data => {
        this.Toastr.info(data.message)
      });

    const editmodal = this.modalService.open(DynamicEditComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<DynamicEditComponent>editmodal.componentInstance).CrudSettings = structure;
    (<DynamicEditComponent>editmodal.componentInstance).ExternalAdd = true;
    (<DynamicEditComponent>editmodal.componentInstance).HideButtons = true;
    (<DynamicEditComponent>editmodal.componentInstance).IsModal = true;
    (<DynamicEditComponent>editmodal.componentInstance).Item = { codiceOtp: '', inizio: this.filtro.inizio, fine: this.filtro.fine, note: ''  };
    (<DynamicEditComponent>editmodal.componentInstance).FromLista = false;
    (<DynamicEditComponent>editmodal.componentInstance).updated.subscribe(data => {
      this.apiPaths.ClassicPost(`${structure.RestRoute}/approvazione`, data ).subscribe(data => {
        this.Refresh();
      })
    });
  }

  Data(data) {
    return this.longWeek ? getWeekDayObjFromString(data, this.giorniFestivi) : getWeekDayObjFromString(data, this.giorniFestivi);
  }

  CreateNewTask(dataInizio, entityObj, task) {
    var tsk = Object.assign({}, task);
    tsk.Tasks = undefined;
    tsk.type = tsk.type ?? this.TaskType;
    var Prototype = { data_inizio_prevista: dataInizio + 'T00:00', data_attivita: dataInizio + 'T00:00', type: this.TaskType };
    Prototype[this.EntityParam] = entityObj?.id;
    Prototype[`${this.EntityParam}Object`] = entityObj;
    var newTask = {
      data_inizio_prevista: dataInizio,
      id: tsk?.id,
      task: tsk ?? Prototype,
    }
    newTask[this.EntityParam] = entityObj?.id;
    newTask[`${this.EntityParam}Object`] = entityObj;
    return newTask;
  }
  getEntityObj(task) {
    return task[`${this.EntityParam}Object`]
  }
  getEntityId(task) {
    return task[`${this.EntityParam}`]
  }

  Refresh() {
    this.filtriService.deleteFiltri(this.location.path())
    console.log("Filtroo" ,this.filtro)
    if(this.filtro?.inizio)
      this.filtriService.addFiltro(this.location.path() + '_inizio', this.filtro.inizio)
    if(this.filtro?.fine)
      this.filtriService.addFiltro(this.location.path() + '_fine', this.filtro.fine)
    if(this.filtro?.ospiteObject)
      this.filtriService.addFiltro(this.location.path() + '_ospiteObject', this.filtro.ospiteObject)
    if(this.filtro?.selectedTipi)
      this.filtriService.addFiltro(this.location.path() + '_selectedTipi', this.filtro.selectedTipi)
    if(this.filtro?.selectedClasse)
      this.filtriService.addFiltro(this.location.path() + '_selectedClasse', this.filtro.selectedClasse)
    this.TaskSctructure = this.campoUtility.getDynamicTaskSctructure(this.TaskType);
    var IntervalloDate = this.TaskService.generateDateArrayEveryXDays(this.filtro.inizio, 1, this.filtro.fine).slice(0, -1);
    const url = this.EntityParam == 'cliente' ? '/anagrafica/clienti/list/dropdown' : '/anagrafica/persone/list';
    var filter = this.EntityParam == 'cliente' ? { page: 0, size: 50, ruolo: 'C', orderBySurname: 'asc',inseriti: undefined, nome: this.filtro?.ospite, occupazione: this.filtro?.selectedClasse?.label ?? undefined  } : { page: 0, size: 50, nome: this.filtro.ospite };
    console.log("Filtro mando", filter)
    if (!this.Entity)
    this.apiPaths.ClassicPost(url, filter).subscribe(data => {
      this.Persone = data.data?.filter(x => !this.filtro?.ospiteObject?.fullName || x?.fullName?.toLowerCase().includes(this.filtro.ospiteObject?.fullName?.toLowerCase()));
      if(!this.Presenze) {
        var url = (this.TaskType == 'P' && this.envirovment.ClientiAddOn['customPresenzeList']) ? '/anagrafica/clienti/presenza/list' : '/task/task/list';
        this.apiPaths.ClassicPost(url, {
          page: 0,
          size: 10,
          tipo: this.TaskType,
          periodo: this.filtro.inizio && this.filtro.fine ? true : false,
          inizio: this.filtro.inizio,
          fine: this.filtro.fine,
          stati: this.filtro?.selectedTipi?.map(x => x.id),
          statoLavorazione: this.report?.statoLavorazione,
          dataLavorazione: this.report?.data
        }).subscribe((response: { data: any[], total: number }) => {
          var Presenze = response.data;
          this.columns = this.GetPresenze(IntervalloDate, this.Persone, Presenze);
          console.log("Presenze: ", this.columns)
        });
      }
      else {
        this.columns = this.GetPresenze(IntervalloDate, this.Persone, this.Presenze);
        console.log("Presenze: ", this.columns)
      }


    });
    else {
      this.Persone = [this.Entity];
      this.apiPaths.ClassicPost('/task/task/list', { page: 0, size: 10, tipo: this.TaskType, periodo: this.filtro.inizio && this.filtro.fine ? true : false, inizio: this.filtro.inizio, fine: this.filtro.fine, stati: this.filtro?.selectedTipi?.map(x => x.id) }).subscribe((response: { data: any[], total: number }) => {
        var Presenze = response.data;
        this.columns = this.GetPresenze(IntervalloDate, this.Persone, Presenze);
        console.log("Presenze: ", this.columns)
      });
    }
  }

  GetPresenze(intervallo: string[], persone: any[], Presenze: any[]){
    //Prime presenze del giorno
    var dummy = intervallo.map(z => Presenze.find(y => this.GetDataOnly(y.data_inizio_prevista) == this.GetDataOnly(z)) ?? { data_inizio_prevista: z, Tasks: [...persone.map(x => { return this.CreateNewTask(z, x, null) }),] });
    console.log("dummy:", dummy);
    Presenze?.forEach(presenza => {
      var val = dummy.find(x => this.GetDataOnly(x.data_inizio_prevista) == this.GetDataOnly(presenza.data_inizio_prevista))
      if (val) {
        if (!val.Tasks)
          val.Tasks = [...persone.map(x => { return this.CreateNewTask(val.data_inizio_prevista, x, null) }),]; // genera le presenze per l'utente se non esiste
        var existing = val.Tasks?.find(x => this.getEntityObj(x)?.id == this.getEntityId(presenza));
        if (existing) {
          existing.id = presenza.id;
          existing.task = presenza;
        }
      }
      else {
        var newTask = Object.assign({}, presenza)
        newTask.Tasks = [...persone.filter(x => x.id != this.getEntityId(presenza)).map(x => { return this.CreateNewTask(presenza.data_inizio_prevista, x, null) }), ...[this.CreateNewTask(presenza.data_inizio_prevista, presenza[`${this.EntityParam}Object`], presenza)]]
        dummy.push(newTask)
      }
    })

    return dummy;
  }
  GetDataOnly(x): string {
    return x?.slice(0, 10);
  }

Stampa(){
  this.apiPaths.FilePost(`${this.TaskSctructure.restRoute}/export`,{inizio: this.filtro.inizio, fine:this.filtro.fine, ospite: this.filtro.ospite, stato:this.filtro?.selectedTipi?.map(x => x.id).find(x=> true) }).subscribe((data) => {
    this.downloadService.downloadFile(data);
  }
);
}


  Tooltip(segmento){
    if(segmento?.tipoObject?.id){
                          switch(segmento?.tipoObject?.id){
                              case 187:
                                return 'Assente/Ricovero'
                              break;
                              case 188:
                                return 'Assente/TSO'
                              break;
                              case 189:
                                return 'Assente/Famiglia'
                              break;
                            case 190:
                              return 'Assente/Altro'
                              break;
                              default:
                                return 'Clicca Qui per inserire una presenza';
                              break;
                          }
                        }else{
                          if(segmento?.stato){
                            switch (segmento?.stato){
                              case 'P':
                                return 'Presente';

                              break;
                              case 'A':
                                return 'Assente';

                              break;
                              case 'D':
                                return 'Dimesso';

                              break;
                              case 'AL':
                                return 'Altro';

                              break;
                              default:
                                return '';
                              break;
                            }
                          }else{
                            return 'Clicca Qui per inserire una presenza'
                          }
                        }

  }
  BadgeSelect(segmento){
    if(segmento?.tipoObject?.id){
      switch(segmento?.tipoObject?.id){
          case 187:
            segmento.name = 'A/R';
            segmento.iconClass = 'e-round e-partial';
          break;
          case 188:
            segmento.name = 'A/TSO';
            segmento.iconClass = 'e-round e-viola';
          break;
          case 189:
            segmento.name = 'A/F';
            segmento.iconClass = 'e-round e-yellow';
          break;
        case 190:
          segmento.name = 'A/A';
          segmento.iconClass = 'e-round e-blue';
          break;
          default:
            segmento.iconClass = 'e-round e-white';
          break;
      }
    }else{
      if(segmento?.stato){
        switch(segmento?.stato){
          case 'P':
            segmento.name = 'P';
            if(this.longWeek)
              segmento.iconClass = 'e-round e-presente'
            else
              segmento.iconClass = 'e-round e-full';
          break;
          case 'A':
            segmento.name = 'A';
            if(this.longWeek)
              segmento.iconClass = 'e-round e-assente';
              else
              segmento.iconClass = 'e-round e-low';
          break;
          case 'D':
            segmento.name = 'D';
            segmento.iconClass = 'e-round e-black';
          break;
          case 'AL':
            segmento.name = 'AL';
            segmento.iconClass = 'e-round e-blue';
          break;
          default:
            segmento.iconClass = 'e-round e-white';
          break;
        }
      }else{
        segmento.iconClass = 'e-round e-white';
      }
    }
    return segmento.iconClass;
  }
  initFilter() {
    const today = new Date();
    console.log("Report: ", this.report)
    var mese = this.report?.mese ? (this.report.mese - 1) : today.getMonth();
    var anno = this.report?.anno ?? today.getFullYear();

    const inizioMese = new Date(anno, mese, 1);
    const fineMese = new Date(anno, mese + 1, 0) ;
    this.filtro.inizio = this.datepipe.transform( inizioMese,'yyyy-MM-dd');
    this.filtro.fine = this.datepipe.transform( fineMese, 'yyyy-MM-dd');
    if(this.envirovment.ClientiAddOn['tipiPresenze'])
      this.filtro.tipi =  this.envirovment.ClientiAddOn['tipiPresenze'];
    else
      this.filtro.tipi =  [{id:'P', label:'Presente'}, {id:'A', label:'Assente'}, {id:'D', label:'Dimesso'}, {id:'AL', label:'Altro'}];
  }



  Click(task?, cliente?, attivita?) {
    var data = attivita?.data_inizio_prevista ? `${attivita?.data_inizio_prevista.slice(0, 10)}T08:00` : null;

    var tosend = task?.id ? task : Object.assign({}, task ?? {type: this.TaskType}, { data_attivita: data, cliente: cliente?.id, clienteObject: cliente});
    this.TaskService.OpenFromTask(tosend, x => {
      this.Refresh();
    });
  }

  showBorderRight(i: number) {
    if(i + 1 > this.columns.length) return ''
    const nextColumn = this.columns[i + 1] as any;
    const thisColumn = this.columns[i] as any;
    if (nextColumn && this.Data(nextColumn.data_inizio_prevista).Festivo && this.longWeek) {
      return '2px solid #f298b8';
    }

    if (nextColumn && this.Data(thisColumn.data_inizio_prevista).Festivo && !this.Data(nextColumn.data_inizio_prevista).Festivo && !this.longWeek) {
      return '2px solid #f298b8';
    }

    return ''
  }

  getClassi(){
    this.apiPaths.ClassicGet('/anagrafica/clienti/occupazioni').subscribe(
      data =>{
        this.classiList = data.map((classe:string) =>{
         return {
            id: classe,
            label: classe
          }
        });

        console.log("Classi", this.classiList)

      }
    )
  }

}




